<script>
    import { getContext, setContext, onMount } from "svelte";
    import { writable } from "svelte/store";
    import { presets } from "../color_schemes.js";
  
    // expose props for customization and set default values
    export let color_schemes = [...presets];
    // set state of current color_scheme's name
  
    let _current = color_schemes[JSON.parse(localStorage.getItem("color_scheme")) != undefined ? JSON.parse(localStorage.getItem("color_scheme")) : 1].name ;
    // utility to get current color_scheme from name
    const getCurrentColorScheme = name => color_schemes.find(h => h.name === name);
    // set up color_scheme store, holding current color_scheme object
    const color_scheme = writable(getCurrentColorScheme(_current));
  
    setContext("color_scheme", {
      // providing color_scheme store through context makes store readonly
      color_scheme: color_scheme,
      toggleColorScheme: () => {
        // update internal state
        let _currentIndex = color_schemes.findIndex(h => h.name === _current);
        let _new_index = _currentIndex === color_schemes.length - 1 ? 0 : (_currentIndex += 1)
        _current = color_schemes[_new_index].name;
  
        localStorage.setItem("color_scheme", JSON.stringify(_new_index));
        // update color_scheme store
        color_scheme.update(t => ({ ...t, ...getCurrentColorScheme(_current) }));
        setRootColors(getCurrentColorScheme(_current));
      },
    });
  
    onMount(() => {
      // set CSS vars on mount
      setRootColors(getCurrentColorScheme(_current));
    });
  
    // sets CSS vars for easy use in components
    // ex: var(--color_scheme-background)
    const setRootColors = color_scheme => {
      for (let [prop, color] of Object.entries(color_scheme.colors)) {
        let varString = `--color_scheme-${prop}`;
        document.documentElement.style.setProperty(varString, color);
      }
      document.documentElement.style.setProperty("--color_scheme-name", color_scheme.name);
    };
  </script>
  
  <slot>
    <!-- content will go here -->
  </slot>